//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getReviewPartnerService } from "./reviewPartnerApi";

export default function useReviewPartnerList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "review-partners/"
      : ""
  }`;
  const service = getReviewPartnerService(scope);

  return { ...service, params, scope, editUrl };
}
